import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDzBfE9vLA1gGQwA8rDvP1jBk0LiGayElI",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "your-questions-answered.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "your-questions-answered",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "your-questions-answered.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "895703532488",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:895703532488:web:e0573430e13923e92ef6fd",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-WNHH1P5QT0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Log Firebase configuration for debugging
// Compare these values with Firebase Console → Project Settings → General
console.log('🔍 Firebase Configuration Check (Compare with Firebase Console):');
console.log('Firebase projectId:', auth.app.options.projectId);
// Log full API key in development for easier comparison
if (process.env.NODE_ENV === 'development') {
  console.log('Firebase apiKey (FULL):', auth.app.options.apiKey || 'MISSING');
} else {
  console.log('Firebase apiKey:', auth.app.options.apiKey ? `${auth.app.options.apiKey.substring(0, 20)}...` : 'MISSING');
}
console.log('Firebase authDomain:', auth.app.options.authDomain);
console.log('Firebase appId:', auth.app.options.appId);
console.log('📋 Compare these values with:');
console.log('   Firebase Console → Project Settings → General → Your apps');
console.log('   Make sure projectId, apiKey, and appId match exactly!');

// Initialize Analytics (only in production)
let analytics = null;
if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;

